var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-content"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"column small-12 text-center pad-area",staticStyle:{"margin-top":"100px"}},[_c('grid-loader')],1),_c('h3',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }